import axios from "axios";
import { Partner_Service_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData, setLogoutFlag } from "./../logout/action";

var map = new HashMap();
var err;

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const EditPartnerActions = {
  GET_PARTNER_VIEW_DETAILS: "GET_PARTNER_VIEW_DETAILS",
  GET_PARTNER_VIEW_DETAILS_SUCCESS: "GET_PARTNER_VIEW_DETAILS_SUCCESS",
  GET_PARTNER_VIEW_DETAILS_ERROR: "GET_PARTNER_VIEW_DETAILS_ERROR",
};

export function getPartnerViewDetails(props) {
  const { access_token, partnerFirmId } = props;
  return (dispatch, getState) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token ?? getState()?.auth?.idToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/getPartnerViewDetails`,
      params: {
        partnerFirmId: partnerFirmId,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAllEngagementDetailsSuccess(response.data));
          return response.data;
        } else if (response.status === 401) {
          dispatch(setLogoutFlag());
        } else {
          const error = new Error(response.error);
          dispatch(getAllEngagementDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getAllEngagementDetailsError(err));

          return err;
        }
        if (!err.response) {
          dispatch(getAllEngagementDetailsError("Internal Server Error!"));
        }
      });
}

export function getAllEngagementDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: EditPartnerActions.GET_PARTNER_VIEW_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
export function getAllEngagementDetailsError(error) {
  return (dispatch) => {
    dispatch({
      type: EditPartnerActions.GET_PARTNER_VIEW_DETAILS_ERROR,
      payload: error,
    });
  };
}



export function saveLeadActivation(props) {
  const { access_token, firmId, leadActivation } = props;
  return (dispatch, getState) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token ?? getState()?.auth?.idToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/leadManagementActivationDeactivation`,
      data: {
        partnerFirmId: firmId,
        leadActivationFlag: leadActivation
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {

          return response.data;
        } else if (response.status === 401) {

        } else {
          const error = new Error(response.error);

          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {


          return err;
        }
        if (!err.response) {
          dispatch(getAllEngagementDetailsError("Internal Server Error!"));
        }
      });
}